import { render, staticRenderFns } from "./main.vendedores.vue?vue&type=template&id=dcab3c0c"
import script from "./main.vendedores.vue?vue&type=script&lang=js"
export * from "./main.vendedores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports